/* eslint-disable max-len */
import React from 'react';
import { Switch, Route, withRouter, NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import { getJson } from 'session';
import { Acl } from 'modules/common/components/Acl';
import TabContainer from './birth/TabContainer';
import TabDeathContainer from './death/TabDeathContainer';
import PSASettingsContainer from './settings/PSASettingsContainer';
import TransactionsContainer from './dashboard/TransactionsContainer';
import TabMarriageContainer from './marriage/TabMarriageContainer';

function CIRSContainer({ match }) {
  const permissions = getJson('permissions');
  return (
    <div className="module-inner">
      <div className="module-inner-title">Civil Registry</div>
      <div className="generic-module-nav mb-3">
        {Acl(permissions, ['VIEW CIVIL REGISTRY']) && (
          <NavLink
            exact
            className="nav-link"
            activeClassName="active"
            to="/civil-registry"
          >
            Dashboard
          </NavLink>
        )}
        {Acl(permissions, ['VIEW BIRTH CERTIFICATE']) && (
          <NavLink
            exact={false}
            className="nav-link"
            activeClassName="active"
            to="/civil-registry/birth-certificate"
          >
            Birth Certificate
          </NavLink>
        )}
        {Acl(permissions, ['VIEW DEATH CERTIFICATE']) && (
          <NavLink
            exact={false}
            className="nav-link"
            activeClassName="active"
            to="/civil-registry/death-certificate"
          >
            Death Certificate
          </NavLink>
        )}
        {Acl(permissions, ['VIEW MARRIAGE CERTIFICATE']) && (
          <NavLink
            exact={false}
            className="nav-link"
            activeClassName="active"
            to="/civil-registry/marriage-certificate"
          >
            Marriage Certificate
          </NavLink>
        )}
        {Acl(permissions, ['VIEW CIVIL REGISTRY SETTINGS']) && (
        <NavLink
          exact={false}
          className="nav-link"
          activeClassName="active"
          to="/civil-registry/settings"
        >
          Settings
        </NavLink>
        )}
      </div>
      <Switch>
        <Route exact path={`${match.path}`} component={TransactionsContainer} />
        <Route
          path={`${match.path}/birth-certificate`}
          component={TabContainer}
        />
        <Route
          path={`${match.path}/death-certificate`}
          component={TabDeathContainer}
        />
        <Route
          path={`${match.path}/marriage-certificate`}
          component={TabMarriageContainer}
        />
        <Route
          path={`${match.path}/settings`}
          component={PSASettingsContainer}
        />
      </Switch>
    </div>
  );
}

CIRSContainer.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
};

export default withRouter(CIRSContainer);
